import { useContext } from 'react';
import { TabBarContext } from './TabBar.context';
import styles from './TabBar.module.scss';
import { Text } from '@components';
import { TEXT_WEIGHT } from '@types';

export type TTabProps = {
	label: string;
	icon?: JSX.Element;
	iconPos?: 'left' | 'right';
	onClick?: (tabIndex: number) => void;
	disabled?: boolean;
	index?: number;
}

export const Tab = (props: TTabProps) => {
	const {
		label,
		icon,
		iconPos = 'left',
		onClick,
		disabled = false,
		index
	} = props;
	const ctx = useContext(TabBarContext);

	const onTabClick = () => {
		if (!disabled) {
			const tabIndex = index ?? 0;
			if (onClick) onClick(tabIndex);
			if (ctx?.setActiveTab) ctx.setActiveTab(tabIndex);
			if (ctx?.onChange) ctx.onChange(tabIndex);
		}
	}

	const isActive = () => ctx?.activeTab === index;

	return (
		<button className={`${styles.tab} ${isActive() ? styles.active : ''}`} onClick={onTabClick} disabled={disabled}>
			{iconPos === 'left' && icon}
			<Text weight={TEXT_WEIGHT.SEMI_BOLD}>{label}</Text>
			{iconPos === 'right' && icon}
		</button>
	);
}
